/*
 * Author: Dw
 * File Created: Thursday, 24-08-01 09:41 am
 * Last Modified: Friday, 25-06-20 06:17 pm, by Dw
 */
import type { CustomAxiosRequestConfig } from '@web/http';
import { get, post } from '@web/http';

import type {
  FileOcrResultRes,
  JumioInfoRes,
  JumioInitParams,
  JumioInitRes,
  KycInfoSubmitParams,
  KycStatusInfo,
  KycStatusInfoParams,
  OriginalSingPassUserProfile,
  UploadPrepareRes,
  UserICFrontImage,
  UserKycAddressInfo,
} from '@/@types/kyc';

// 初始化 singpass
export const initializeSingpass = (url: string) => get(url);

// singpass info 回调数据
export const singpassCallbackInfo = async (
  skey: string,
  req?: CustomAxiosRequestConfig['req'],
) =>
  get<OriginalSingPassUserProfile>(
    `/gateway/kyc/public/v1/query-singpass-info`,
    { skey },
    { req },
  );

// jumio init
export const initializeJumio = (params: JumioInitParams) =>
  post<JumioInitRes>('/gateway/kyc/private/v1/kyc-init', params);

// jumio info
// todo
export const getJumioInfo = () => {
  return get<JumioInfoRes>('/gateway/kyc/private/v1/get-jumio-info');
};

export const kycInfoSubmit = (params: Partial<KycInfoSubmitParams>) => {
  return post('/gateway/kyc/private/v1/kyc-info-submit', {
    ...params,
  });
};

export const getKycStatus = (
  params?: KycStatusInfoParams,
  req?: CustomAxiosRequestConfig['req'],
) => {
  return post<KycStatusInfo>(`/gateway/kyc/private/v1/get-kyc-status`, params, {
    req,
  });
};

export const uploadPrepare = (fileNames: string[]) => {
  return post<UploadPrepareRes>(`/gateway/kyc/private/v1/file-upload-prepare`, {
    fileNames,
  });
};

// filePath is objectKey from uploadPrepare
export const getOcrResult = () => {
  return get<FileOcrResultRes | null>('/gateway/kyc/private/v1/get-ocr-result');
};

export const getUserAddress = () => {
  return get<UserKycAddressInfo>('/gateway/kyc/private/v1/get-user-address');
};

export const getUserFrontSidePic = () => {
  return get<UserICFrontImage>('/gateway/kyc/private/v1/get-identity-file');
};
